module.exports = __webpack_public_path__ + "img/silo.703e9f40.jpeg";